import { render, staticRenderFns } from "./DemoDatePicker.vue?vue&type=template&id=54ff5472"
import script from "./DemoDatePicker.vue?vue&type=script&lang=js"
export * from "./DemoDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports